module.exports = __webpack_public_path__ + "bb5ccc8acbb8a43e64b2d49920e01dae.jpg";